import * as Sentry from '@sentry/react'

import { GraphQLError } from 'graphql'

export const captureGraphQLError = (graphQLError: GraphQLError): void => {
  Sentry.withScope((scope) => {
    scope.setTag('api_error_kind', 'graphql')

    const { extensions } = graphQLError

    if (extensions?.code) {
      scope.setTag('gql_error_code', String(extensions.code))
    }

    try {
      scope.setExtra('error_payload', JSON.stringify(graphQLError))
    } catch {
      scope.setExtra('error_payload', String(graphQLError))
    }

    Sentry.captureException(new Error(`GraphQL error: ${graphQLError.message}`))
  })
}
